const identificationTypes = {
  ZPAR: {
    items: [
      {
        id: 'DNI',
        name: 'DNI',
        type: 'number',
        min_length: '7',
        max_length: '8'
      },
      {
        id: 'CI',
        name: 'Cédula',
        type: 'number',
        min_length: '1',
        max_length: '9'
      },
      {
        id: 'LC',
        name: 'L.C.',
        type: 'number',
        min_length: '6',
        max_length: '7'
      },
      {
        id: 'LE',
        name: 'L.E.',
        type: 'number',
        min_length: '6',
        max_length: '7'
      },
      {
        id: 'Otro',
        name: 'Otro',
        type: 'number',
        min_length: '5',
        max_length: '20'
      }
    ]
  },
  IWBR: {
    items: [
      {
        id: 'CPF',
        name: 'CPF',
        type: 'number',
        min_length: '11',
        max_length: '11'
      },
      {
        id: 'CNPJ',
        name: 'CNPJ',
        type: 'number',
        min_length: '14',
        max_length: '14'
      }
    ]
  },
  WIBR: {
    items: [
      {
        id: 'CPF',
        name: 'CPF',
        type: 'number',
        min_length: '11',
        max_length: '11'
      },
      {
        id: 'CNPJ',
        name: 'CNPJ',
        type: 'number',
        min_length: '14',
        max_length: '14'
      }
    ]
  },
  UBPE: {
    items: [
      {
        id: 'DNI',
        name: 'DNI',
        type: 'number',
        min_length: '8',
        max_length: '8'
      },
      {
        id: 'C.E',
        name: 'C.E',
        type: 'number',
        min_length: '8',
        max_length: '12'
      },
      {
        id: 'RUC',
        name: 'RUC',
        type: 'string',
        min_length: '11',
        max_length: '12'
      },
      {
        id: 'Otro',
        name: 'Otro',
        type: 'number',
        min_length: '5',
        max_length: '20'
      }
    ]
  },
  DVPE: {
    items: [
      {
        id: 'DNI',
        name: 'DNI',
        type: 'number',
        min_length: '8',
        max_length: '8'
      },
      {
        id: 'C.E',
        name: 'C.E',
        type: 'number',
        min_length: '8',
        max_length: '12'
      },
      {
        id: 'RUC',
        name: 'RUC',
        type: 'string',
        min_length: '11',
        max_length: '12'
      },
      {
        id: 'Otro',
        name: 'Otro',
        type: 'number',
        min_length: '5',
        max_length: '20'
      }
    ]
  }
};

const taxConditions = {
  ZPAR: {
    items: [
      {
        id: '1',
        description: 'Responsable Inscripto',
        taxLabel: 'CUIT',
        enabled: true,
        required: true
      },
      {
        id: '3',
        description: 'Exento',
        taxLabel: 'CUIT',
        enabled: true,
        required: true
      },
      {
        id: '4',
        description: 'Consumidor Final',
        taxLabel: 'CUIT',
        enabled: true,
        required: true
      },
      {
        id: '5',
        description: 'Monotributo',
        taxLabel: 'CUIT',
        enabled: true,
        required: true
      }
    ]
  },
  '24MX': {
    items: [
      {
        id: '6',
        description: 'MX Sin obligaciones Fiscales (CURP)',
        taxLabel: 'CURP',
        enabled: true,
        required: true
      },
      {
        id: '301',
        description: 'RFC Persona Moral',
        taxLabel: 'RFC',
        enabled: true,
        required: true
      },
      {
        id: '319',
        description: 'RFC Persona Física',
        taxLabel: 'RFC',
        enabled: true,
        required: true
      }
    ]
  },
  VAMX: {
    items: [
      {
        id: '1006',
        description: 'MX Sin obligaciones Fiscales (CURP)',
        taxLabel: 'CURP',
        enabled: true,
        required: true
      },
      {
        id: '1301',
        description: 'RFC Persona Moral',
        taxLabel: 'RFC',
        enabled: true,
        required: true
      },
      {
        id: '1319',
        description: 'RFC Persona Física',
        taxLabel: 'RFC',
        enabled: true,
        required: true
      }
    ]
  },
  IWBR: {
    items: [
      {
        id: '9',
        description: 'CNPJ',
        taxLabel: 'CNPJ',
        enabled: true,
        required: false
      },
      {
        id: '14',
        description: 'CPF',
        taxLabel: 'CPF',
        enabled: true,
        required: false
      }
    ]
  },
  WIBR: {
    items: [
      {
        id: '9',
        description: 'CNPJ',
        taxLabel: 'CNPJ',
        enabled: true,
        required: false
      },
      {
        id: '14',
        description: 'CPF',
        taxLabel: 'CPF',
        enabled: true,
        required: false
      }
    ]
  },
  CMBR: {
    items: [
      {
        id: '9',
        description: 'CNPJ',
        taxLabel: 'CNPJ',
        enabled: true,
        required: false
      },
      {
        id: '14',
        description: 'CPF',
        taxLabel: 'CPF',
        enabled: true,
        required: false
      }
    ]
  },
  UBPE: {
    items: [
      {
        id: '324',
        description: 'RUC',
        taxLabel: 'RUC',
        enabled: true,
        required: false
      },
      {
        id: '325',
        description: 'DNI',
        taxLabel: 'DNI',
        enabled: true,
        required: false
      },
      {
        id: '329',
        description: 'Otro Tipo Doc',
        taxLabel: 'Otro Tipo Doc',
        enabled: true,
        required: false
      }
    ]
  },
  DVPE: {
    items: [
      {
        id: '302',
        description: 'RUC',
        taxLabel: 'RUC',
        enabled: true,
        required: false
      },
      {
        id: '314',
        description: 'DNI',
        taxLabel: 'DNI',
        enabled: true,
        required: false
      },
      {
        id: '318',
        description: 'Otro Tipo Doc',
        taxLabel: 'Otro Tipo Doc',
        enabled: true,
        required: false
      }
    ]
  },
  CAPA: {
    items: [
      {
        id: '307',
        description: 'RUC',
        taxLabel: 'RUC',
        enabled: true,
        required: false
      },
      {
        id: '321',
        description: 'CI Cédula',
        taxLabel: 'CI Cédula',
        enabled: true,
        required: false
      }
    ]
  },
  PLEC: {
    items: [
      {
        id: '304',
        description: 'Contribuyente',
        taxLabel: 'Contribuyente',
        enabled: true,
        required: false
      },
      {
        id: '311',
        description: 'Cédula',
        taxLabel: 'Cédula',
        enabled: true,
        required: false
      }
    ]
  }
};

function getIdentificationTypes(siteId) {
  if (identificationTypes[siteId]) {
    return identificationTypes[siteId].items;
  }
  return [];
}

function getTaxConditions(siteId) {
  if (taxConditions[siteId]) {
    return taxConditions[siteId].items;
  }
  return [];
}

export { getIdentificationTypes, getTaxConditions };
